<script lang="ts" module>
  import { onDestroy } from 'svelte';

  import type { Instruction } from '@/teoCore/TeoApi';
  import type { TeoText } from '@/teoCore/text/TeoText';
  import InstructionCard, {
    type InstructionExtended,
  } from '@/ui/components/assistant/Performance/InstructionCard/InstructionCard.svelte';
  import ContentCard from '@/ui/elements/card/ContentCard.svelte';
  import InfoCard from '@/ui/elements/card/InfoCard.svelte';
  import { useTeoTextUiStateObserver } from '@/utils/use-teo-event-observer.svelte';

  import AiComponent from '../Performance/AIComponent.svelte';
  import InitCard from '../Performance/InitCard/InitCard.svelte';
</script>

<script lang="ts">
  const { teoText }: { teoText: TeoText } = $props();
  let instruction: InstructionExtended | undefined = $state(teoText.style.currentInstruction);
  let category = useTeoTextUiStateObserver(teoText.ui, 'styleCategory');
  let loading = $state(false);
  let showAi = $state(false);

  // Listen for style handler events
  teoText.style.events.addEventListener('instructionChanged', onInstructionChanged);
  teoText.style.events.addEventListener('loading', onLoading);

  onDestroy(() => {
    teoText.style.events.removeEventListener('instructionChanged', onInstructionChanged);
    teoText.style.events.removeEventListener('loading', onLoading);
  });

  $effect(() => {
    // React to category changes
    if (category.current) {
      teoText.style.currentCategory = category.current;
    }
  });

  $effect(() => {
    if (!instruction || !instruction.ai_prompts.length) {
      showAi = false;
      if (teoText.ai.isEnabled) {
        teoText.ai.disableAiMode();
      }
    } else {
      showAi = true;
    }
  });

  function onInstructionChanged(newInstruction: Instruction | undefined) {
    instruction = newInstruction;
    if (instruction) instruction.color = 'info';
  }

  function onLoading(isLoading: boolean) {
    loading = isLoading;
  }
</script>

{#if instruction}
  <div class="flex flex-col space-y-4">
    <InstructionCard cardLabel="Stilhinweis" {instruction} />
    {#if showAi}
      <AiComponent {teoText}></AiComponent>
    {/if}
  </div>
{:else if teoText.analysis}
  <ContentCard {loading} cardLabel="Stilhinweis">
    <InfoCard
      shortText="Wähle auf der linken Seite eine Kategorie, um Informationen zu den Stil-Kriterien des Textes zu erhalten."
    ></InfoCard>
  </ContentCard>
{:else if loading}
  <InitCard text={teoText} cardLabel="Stilhinweis" {loading}></InitCard>
{:else}
  <InitCard text={teoText} cardLabel="Stilhinweis" {loading}></InitCard>
{/if}
